export { default } from "./NoteItemView";
